import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { useAccountStore } from '../../components/Stores/accountStore';
import { useExposureStore } from '../../components/Stores/exposureDataStore';
import { useMaterialsStore } from '../../components/Stores/MaterialsStore';
import { getMaterialsCardData } from '../Dashboard/dashboardUtils';
import { MaterialTrendButton } from '../Dashboard/MaterialTrendButton';
import { LoadingLogoComponent } from '../Quotes/LoadingLogoComponent';
import { OpportunitySummaryDashboard } from './components/SummaryDashboard/SummaryDashboard';
import { TransactionTable } from './components/TransactionTable/TransactionTable';
import { getUpdatedTransactionOpportunity } from './opportunityDashboardUtils';
import { transactionOpportunitiesMock } from './opportunityTransactionsMock';
import { useTransaction } from '../../hooks/useTransactionByAccount';
import { useCurrencyRates } from '@hooks/useCurrencyRates';

export const OpportunityDashboard = () => {
  const { materialsMap } = useMaterialsStore();
  const { materialColorDictionary: colorsMap, account } = useAccountStore();
  const { convertionMap } = useCurrencyRates();

  const { materialsToAccount } = account;
  const { currentSelectedMaterialId, netExposure, setCurrentSelectedMaterialId } = useExposureStore();
  const { data: transactionsFetchedData } = useTransaction();
  const [transactionDataSet, setTransactionDataSet] = useState(transactionOpportunitiesMock);
  const [filteredTransactions, setFilteredTransactions] = useState(
    getUpdatedTransactionOpportunity(transactionDataSet, currentSelectedMaterialId, materialsMap),
  );

  useEffect(() => {
    transactionsFetchedData && transactionsFetchedData.length && setTransactionDataSet(transactionsFetchedData);
  }, [transactionsFetchedData]);

  useEffect(() => {
    setFilteredTransactions(
      getUpdatedTransactionOpportunity(transactionDataSet, currentSelectedMaterialId, materialsMap),
    );
  }, [currentSelectedMaterialId, materialsMap, transactionDataSet]);

  useEffect(() => {
    const ShowToast = () =>
      !filteredTransactions.length && showToast('No Transactions available for this material', '1');

    ShowToast();
  }, [filteredTransactions]);

  return (
    <>
      {account && materialsMap ? (
        <div className="flex flex-1 flex-col h-full gap-6 pb-4 pe-2 overflow-hidden">
          <MaterialTrendButton
            buttons={getMaterialsCardData(materialsMap, colorsMap, convertionMap, materialsToAccount, netExposure)}
            currentMaterial={currentSelectedMaterialId}
            setCurrentMaterial={setCurrentSelectedMaterialId}
          />
          <div className="flex shadow-custom max-h-[15rem] overflow-hidden ">
            <OpportunitySummaryDashboard data={filteredTransactions} />
          </div>
          <div className="flex flex-1 overflow-auto shadow-custom">
            <TransactionTable data={filteredTransactions} />
          </div>
        </div>
      ) : (
        <LoadingLogoComponent />
      )}
    </>
  );
};

const showToast = (message: string, toastId: string) => {
  if (!toast.isActive(toastId)) {
    toast.info(message, {
      toastId,
    });
  }
};
